import Vue from "vue";
import Vuetify from "vuetify/lib";
import component from "./components";
import i18n from "@/plugins/I18n";

Vue.use(Vuetify);

Vue.use(component);
import "vuetify/dist/vuetify.min.css";

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      light: {
        success: "#49bb8b",
        primary: "#0096B2",
        error: "#EB5757",
        warning: "#e2c25d",
        grey: "#DCDCDC",
        lightSuccess: "#A2F6A0",
        purple: "#9747FF",
        lightGrey: "#7A889B",
        // snow: "#ffff",
      },
    },
  },
});
